import React, { Fragment } from 'react'
import { Col, Row } from 'reactstrap'
import Skeleton from 'react-loading-skeleton';

const LoadingDetailPerusahaan = function (props) {
    return (
        <Fragment>
            <Row>
                <Col md="6">
                    <h2>
                        <Skeleton />
                    </h2>
                    <h4>
                        <Skeleton width={200} />
                    </h4>
                    <h4>
                        <Skeleton width={200} />
                    </h4>
                </Col>
            </Row>
            <hr />
            <Row>
                <Col md="3">
                    <Skeleton height={80} />
                </Col>
                <Col md="3">
                    <Skeleton height={80} />
                </Col>
                <Col md="3">
                    <Skeleton height={80} />
                </Col>
                <Col md="3">
                    <Skeleton height={80} />
                </Col>
            </Row>

            <Row className="mt-4">
                <Col md="12">
                    <Skeleton height={50} />
                </Col>
            </Row>


            <Row
                className="mt-4"
            >
                <Col md="4">
                    <Skeleton height={50} />
                </Col>
                <Col md="4">
                    <Skeleton height={50} />
                </Col>
                <Col md="4">
                    <Skeleton height={50} />
                </Col>
            </Row>

            <Row
                className="mt-4"
            >
                <Col md="4">
                    <Skeleton height={50} />
                </Col>
                <Col md="4">
                    <Skeleton height={50} />
                </Col>
                <Col md="4">
                    <Skeleton height={50} />
                </Col>
            </Row>
            <style jsx>{`
                .
            `}</style>
        </Fragment>
    );
};

export default LoadingDetailPerusahaan;
